class ComponentStats extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.elements = this.querySelectorAll("[data-count]");
    this.animatedElements = new Set();

    this.elements.forEach((element) => {
      this.initItem(element);
    });
  }

  initItem(element) {
    const from =
      parseInt(element.dataset.startValue.replace(/,/g, ""), 10) || 0;
    const to = parseInt(element.dataset.endValue.replace(/,/g, ""), 10) || 0;
    const speed = 2;
    let current = from;

    const animateCount = () => {
      current += (to - from) / (speed * 60);

      if ((to > from && current >= to) || (to < from && current <= to)) {
        current = to;
        element.textContent =
          this.formatNumber(Math.round(current)) + element.dataset.unit;

        return;
      }

      element.textContent =
        this.formatNumber(Math.round(current)) + element.dataset.unit;
      requestAnimationFrame(animateCount);
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.animatedElements.has(element)) {
          this.animatedElements.add(element);
          current = from;
          animateCount();
          observer.disconnect();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0.5,
    });

    observer.observe(element);
  }

  formatNumber(value) {
    return value.toLocaleString("en-US");
  }
}

customElements.define("component-stats", ComponentStats);
